import { useQuery } from "react-query";

import { adminApis, queryKeys } from "./index";

export const useGetTotalInfo = () => {
  return useQuery([queryKeys.JACKPOT_TOTAL_INFO], adminApis.getTotalInfo, {
    keepPreviousData: true,
  });
};
